var _ = require('underscore');
var $ = require('jquery');
var Core = require('../core/core.js');

class DashboardButton extends Core {
  _defaults() {
    return {
      target: '.js-editor',
      fields: {
        'text': '',
      }
    };
  }

  constructor(options) {
    super(options);

    this.template = `
      <div class="editor__dashboard__button">
        <a href="" class="js-editor__dashboard__button">
          <div class="editor__dashboard__button__container">
            <div class="editor__dashboard__button__icon"></div>
            <div class="editor__dashboard__button__text"><%- text %></div>
          </div>
        </a>
      </div>
    `;

    super.render();

    $('.js-editor__dashboard__button', this.$el).on('click', this._btnClicked)
  }

  _btnClicked(e) {
    e.preventDefault();
    $(e.currentTarget).trigger('Cioui:DashboardButton:clicked');
  }
}
module.exports = DashboardButton;
